module.exports = "https://static.energy5.com/_next/static/images/twitter-99d59f29a8f54c483e705e9d91d8a462.png";